import angular from "angular";

export function QpTotopDirective($interval: angular.IIntervalService): ng.IDirective {
    return {
        link: (scope, element, attributes) => {
            function _scrollTo(topSize: number) {
                let intervalPromise = $interval(() => {
                    topSize -= 100;
                    window.scrollTo(0, topSize);
                    if (topSize <= 0) {
                        $interval.cancel(intervalPromise);
                    }
                }, 30)
            }
            function displayHandler() {
                // 获取页面可视区域高度
                // let clientHeight = document.documentElement.clientHeight;
                // 获取滚动条的位置
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

                if (scrollTop >= 200) {
                    element.removeClass("top-hide");
                    element.addClass("top-show");
                } else {
                    element.removeClass("top-show");
                    element.addClass("top-hide");
                }
            }

            // TODO 当滚动条位置大于一半可视区域高度时,显示当前元素(后续允许通过provider配置元素显示时的滚动条位置)
            window.onscroll = () => {
                displayHandler();
            }

            // 监听点击事件,触发返回顶部
            element.on("click", () => {
                // 获取滚动条的位置
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                _scrollTo(scrollTop);
            })

            displayHandler();
        }
    }
}

QpTotopDirective.$inject = ["$interval"];